import { isGrantReviewPortal } from "@/environment";

export default {
  to: "/dashboard/application-list",
  order: 2,
  icon: "mdi-account-details",
  title: "Applications By Status",
  disabled: JSON.parse(isGrantReviewPortal) ? true : false,
  sublinks: [
    {
      to: `/dashboard/application/list?status=Review`,
      order: 1,
      title: "Review",
      disabled: false,
      icon: "mdi-format-list-numbered",
    },
    {
      to: `/dashboard/application/list?status=New`,
      order: 1,
      title: "New",
      disabled: false,
      icon: "mdi-invoice-text-plus",
    },
    {
      to: `/dashboard/application/list?status=OnHold`,
      order: 1,
      title: "OnHold",
      disabled: false,
      icon: "mdi-gesture-tap-hold",
    },
    {
      to: `/dashboard/application/list?status=Rejected`,
      order: 1,
      title: "Rejected",
      disabled: false,
      icon: "mdi-account-multiple-remove",
    },
    {
      to: `/dashboard/application/reports`,
      order: 2,
      title: "Reports",
      disabled: false,
      icon: "mdi-file-chart",
    },
  ],
};
